<template>
  <div
    class="fixed inset-0 bg-manypenny-primary-dark flex items-center justify-center"
  >
    <img class="w-32 h-32" src="../images/manypenny-logo.svg" />
  </div>
</template>
